import parser from 'html-react-parser';
import React, { useState, useEffect, useRef } from 'react';

const ClampedText = ({ content, initialClampLines = 4, className, classNames = {} }) => {
  const contentRef = useRef(null);
  const [isClamped, setIsClamped] = useState(true);
  const [needsReadMore, setNeedsReadMore] = useState(false);

  useEffect(() => {
    const checkClamping = () => {
      if (contentRef.current) {
        contentRef.current.classList.add(`line-clamp-${initialClampLines}`);
        contentRef.current.classList.remove('line-clamp-none');

        const hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
        setNeedsReadMore(hasOverflow);

        if (!isClamped) {
          contentRef.current.classList.remove(`line-clamp-${initialClampLines}`);
          contentRef.current.classList.add('line-clamp-none');
        }
      }
    };

    const timeoutId = setTimeout(checkClamping, 50);
    window.addEventListener('resize', checkClamping);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkClamping);
    };
  }, [content, isClamped, initialClampLines]);

  const toggleClamp = () => {
    setIsClamped(!isClamped);
  };

  if (!content) return null;

  const clampClass = isClamped ? `line-clamp-${initialClampLines}` : 'line-clamp-none';
  const isHTML = /<[a-z][\s\S]*>/i.test(content);

  const defaultContentClasses = 'prose prose-sm max-w-none mb-4 text-gray-600 description-content overflow-hidden';
  const defaultButtonClasses = 'text-green-500 text-xs font-medium hover:underline mt-1 mb-3';

  const contentFinalClasses =
    `${classNames.content || defaultContentClasses} ${clampClass} ${className || ''}`.trim();
  const buttonFinalClasses = `${classNames.button || defaultButtonClasses}`.trim();

  return (
    <>
      <div ref={contentRef} className={contentFinalClasses}>
        {isHTML ? parser(content) : content}
      </div>
      {needsReadMore && (
        <button type="button" onClick={toggleClamp} className={buttonFinalClasses}>
          {isClamped ? 'Selengkapnya' : 'Sembunyikan'}
        </button>
      )}
    </>
  );
};
export default ClampedText;
